import {ApolloClient, InMemoryCache} from "@apollo/client";

const appCache = new InMemoryCache();

export const apolloClient = new ApolloClient({
    cache: appCache,
    uri: document.location.host.indexOf("localhost") > -1 ? "http://localhost:8888/query"  : "/query",
})
